import { type Action, createHook, createStore } from 'react-sweet-state';
import type { TableRef } from '../../common/types/base-table';

type StoreType = {
	tableRef: TableRef;
};

const actions = {
	setTableRef:
		(tableRef: TableRef): Action<StoreType> =>
		({ setState }) => {
			setState({ tableRef });
		},
};

type Actions = typeof actions;

const TableRefStore = createStore<StoreType, Actions>({
	initialState: {
		tableRef: { current: null },
	},
	actions,
	name: 'JWMTableRef',
});

export const useTableRefStore = createHook(TableRefStore);
